import script from "./MenuListCom.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuListCom.vue?vue&type=script&setup=true&lang=js"

import "./MenuListCom.vue?vue&type=style&index=0&id=6c6215b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c6215b8"]])

export default __exports__